<template>
  <el-dialog :title="title" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="800px" v-loading="loading">
    <el-form ref="form" :model="detalheLancamento" :rules="validacao" size="small" label-position="top" hide-required-asterisk :show-message="false" style="padding:0;">

      <el-row :gutter="10" style="margin-top: -40px">
        <el-col :span="24" style="text-align: center;">
          <h3>{{header}}</h3>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Forma de Pagamento " prop="formaPagamento">
            <el-select v-model="detalheLancamento.formaPagamento" clearable value-key="data" placeholder="" filterable default-first-option style="width: 100%">
              <el-option v-for="item in formasPagamento" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Valor" prop="valor">
            <money auto-complete="off" v-model="detalheLancamento.valor" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button @click="adicionarDetalhesLancamentoCaixa('form')" type="primary" size="small" style="margin-top:17px;" round class="btn-box-shadow">Adicionar</el-button>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirFormCheque">
        <el-col :span="5">
          <el-form-item label="Banco" prop="bancoCheque">
            <el-select v-model="detalheLancamento.bancoCheque" clearable value-key="data" placeholder="" filterable default-first-option style="width: 100%">
              <el-option v-for="item in bancos" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Agência" prop="agenciaCheque">
            <el-input size="small" v-model="detalheLancamento.agenciaCheque"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Nº Cheque" prop="numeroCheque">
            <el-input size="small" v-model="detalheLancamento.numeroCheque"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Data" prop="dataCheque">
            <el-date-picker
              size="small"
              v-model="detalheLancamento.dataCheque"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7" v-if="tipoRecibo === 'ALUGUEL'">
          <el-form-item label=" " prop="contasReceber">
            <el-checkbox v-model="detalheLancamento.contasReceber">Inserir no Contas a Receber</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-table
            :data="detalhesLancamento"
            empty-text="Nenhum Item"
            size="small"
            height="150"
            style="background-color: #FFFFFF; "
            stripe
            highlight-current-row>
            <el-table-column label="Forma de Pagamento" prop="formaPagamento" width="150" :formatter="getFormaPagamento"/>
            <el-table-column label="Banco" prop="bancoCheque" :formatter="getBanco"/>
            <el-table-column label="Agência" prop="agenciaCheque"/>
            <el-table-column label="Nº Cheque" prop="numeroCheque"/>
            <el-table-column label="Data" prop="dataCheque"/>
            <el-table-column label="Valor" prop="valor" width="100" :formatter="getValor"/>
            <el-table-column width="80" column-key="acoes">
              <template slot-scope="scope">
                <el-button @click.native.prevent="deleteRow(scope.$index, detalhesLancamento)" type="text" size="small" style="padding: 0px; color: #F56C6C;">Remover</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top:20px;">
        <el-col :span="24" style="text-align: right">
          <strong>Total: {{ formatarValor(this.somatorioItensLancamento) }}</strong>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer">
        <el-button @click="pagar" type="primary" size="small" round class="btn-box-shadow">{{ this.tipoRecibo === 'ALUGUEL' ? 'Pagar Recibo' : this.tipoRecibo === 'REPASSE' ? 'Liberar Repasse' : 'Pagar Boleto'}}</el-button>
    </span>
  
  </el-dialog>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import Util from '../../util/funcoes.js';
import { FORMA_PAGAMENTO_LANCAMENTO_CAIXA, BANCOS } from '../../util/constantes.js';
import { Money } from "v-money";

export default {
  props: {
    recibo: Object,
    tipoRecibo: String,
    totalDoAluguel: Number,
    visibility: Boolean,
  },
  components: {
    Money
  },
  data() {
    return {
      reciboRecuperado: {
        ...this.recibo
      },
      detalheLancamento: {},
      detalhesLancamento: [],

      validacao: {
        valor: [
          { required: true},
          { type: 'number', min: 0.1}
        ],
        bancoCheque: [{ required: true}],
        agenciaCheque: [{ required: true}],
        numeroCheque: [{ required: true}],
        dataCheque: [{ required: true}],
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_ALUGUEL" })[0] }
    }),
    formasPagamento() {
      return FORMA_PAGAMENTO_LANCAMENTO_CAIXA;
    },
    bancos() {
      return BANCOS;
    },
    header(){
      if(this.tipoRecibo === 'ALUGUEL'){
        return "Valor do Aluguel - " + this.formatarValor(this.totalDoAluguel)
      } else if(this.tipoRecibo === 'REPASSE'){
        return "Valor do Repasse - " + this.formatarValor(this.totalDoAluguel)
      } else {
        return "Valor do Boleto - " + this.formatarValor(this.totalDoAluguel)
      }
    },
    title(){
      if(this.tipoRecibo === 'ALUGUEL'){
        return "Pagar Aluguel - Caixa da Imobiliária"
      } else if(this.tipoRecibo === 'REPASSE'){
        return "Liberar Repasse - Caixa da Imobiliária"
      } else {
        return "Pagar Boleto Avulso - Caixa da Imobiliária"
      }
    },
    exibirFormCheque() {
      return this.detalheLancamento.formaPagamento && this.detalheLancamento.formaPagamento === 'CHEQUE'
    },
    somatorioItensLancamento()  {
        let somatorio = 0;
        this.detalhesLancamento.forEach(item => {
          somatorio += Number(item.valor) || 0;
        });

        return parseFloat(somatorio.toFixed(2));
    },
    util() {
      return Util;
    },
    loading() {
      return this.$store.state.loading;
    }
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
        'pagarRecibo'
    ]),

    iniciar(){
      this.reciboRecuperado = {
        ...this.recibo
      },
      this.detalheLancamento = {},
      this.detalhesLancamento = []
    },
    adicionarDetalhesLancamentoCaixa(formName) {
      const somatorioAtual = Number(this.somatorioItensLancamento.toFixed(2));
      const novoValor = Number(this.detalheLancamento.valor) || 0;
      const totalComNovo = Number((somatorioAtual + novoValor).toFixed(2));
      const totalAluguel = Number(this.totalDoAluguel.toFixed(2));

      if(totalAluguel >= totalComNovo) {
        this.$refs[formName].validate((valid) => {
          if (valid && this.detalheLancamento.formaPagamento) {
            this.detalhesLancamento.push({...this.detalheLancamento})
            this.detalheLancamento = {}
          } else {
            this.$message.error("Preencha todos os campos obrigatórios!");
            return false;
          }
        });
      } else {
        this.$message.error("O total dos lançamentos é maior que o valor do aluguel!");
      }
    },
    pagar() {
      if(this.tipoRecibo == "ALUGUEL") {
        this.pagarAluguelHandler();
      } else if(this.tipoRecibo == "REPASSE") {
        this.liberarRepasseHandler();
      } else {
        this.pagarBoletoAvulsoHandler();
      }
    },
    
    pagarAluguelHandler() {
      if(this.totalDoAluguel === this.somatorioItensLancamento) {
        this.$emit('pagarAluguel',this.detalhesLancamento);
      } else {
        this.exibirAlert("Atenção", "O total dos lançamentos cadastrados é menor que o valor do aluguel");
      }
    },
    
    liberarRepasseHandler() {
      if(this.totalDoAluguel === this.somatorioItensLancamento || this.totalDoAluguel < 0) {
        this.$emit('liberarRepasse',this.detalhesLancamento);
      } else {
        this.exibirAlert("Atenção", "O total dos lançamentos cadastrados é menor que o valor do repasse");
      }
    },

    pagarBoletoAvulsoHandler() {
      if(this.totalDoAluguel === this.somatorioItensLancamento) {
        this.$emit('pagarBoletoAvulso',this.detalhesLancamento);
      } else {
        this.exibirAlert("Atenção", "O total dos lançamentos cadastrados é menor que o valor do aluguel");
      }
    },

    // UTIL
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    getFormaPagamento(item){
      return Util.getLabel(this.formasPagamento,item.formaPagamento)
    },
    getBanco(item){
      return Util.getLabel(this.bancos,item.bancoCheque)
    },
    getValor(item){
      return Util.formatarValor(item.valor)
    },
    formatarValor(valor) {
      return Util.formatarValor(valor)
    },
    exibirAlert(titulo, mensagem) {
        this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    fechar() {
      this.$emit('close');
    } 
  }
}
</script>
